module.exports = __webpack_public_path__ + "static/monier-6badb12852be8fd0ffa23bad81063ab8.jpg";